import React, { useEffect, useState } from 'react';
import { StatCard } from '../../components/ui/StatCard';
import { Card } from '../../components/ui/Card';
import { Table, Tr, Td } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Notice } from '../../components/ui/Notice';
import { getHotels } from '../../api/hotels';
import { getBookings } from '../../api/bookings';
import { getWallet } from '../../api/wallet';
import { formatCurrency, formatDate } from '../../utils/format';

export const HotelDashboard: React.FC = () => {
  const [hotels, setHotels] = useState<any[]>([]);
  const [bookings, setBookings] = useState<any[]>([]);
  const [wallet, setWallet] = useState<any>(null);

  useEffect(() => {
    getHotels().then(r => setHotels(r.data.results || r.data));
    getBookings().then(r => setBookings(r.data.results || r.data));
    getWallet().then(r => setWallet(r.data));
  }, []);

  const hotel = hotels[0];
  const confirmed = bookings.filter((b: any) => b.status === 'confirmed').length;

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 4 }}>{hotel?.name || 'Hotel Dashboard'}</h1>
      <div style={{ fontSize: 13, color: '#888780', marginBottom: 20 }}>{hotel?.city} · {hotel?.star_rating} bintang</div>
      <Notice type="info">Base rate hotel hanya terlihat oleh Hotel Admin dan Superadmin. Agen hanya melihat harga final setelah markup.</Notice>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 20 }}>
        <StatCard label="Total booking" value={bookings.length} sub={`${confirmed} confirmed`} />
        <StatCard label="Booking pending" value={bookings.filter((b: any) => b.status === 'pending').length} />
        <StatCard label="Wallet balance" value={wallet ? formatCurrency(wallet.balance) : '—'} sub="Settlement hotel" />
        <StatCard label="System incentive" value={hotel ? `${hotel.incentive_percent}%` : '—'} sub="Default per booking" />
      </div>
      <div style={{ marginBottom: 16 }}>
        <Card title="Booking masuk">
          <Table headers={['Kode', 'Kamar', 'Tamu', 'Checkin', 'Malam', 'Total', 'Agen', 'Status']}>
            {bookings.slice(0, 10).map((b: any) => (
              <Tr key={b.id}>
                <Td><span style={{ fontFamily: 'monospace', fontSize: 11 }}>{b.booking_code}</span></Td>
                <Td style={{ fontSize: 12 }}>{b.room_type}</Td>
                <Td style={{ fontSize: 12 }}>{b.guest_name}</Td>
                <Td style={{ fontSize: 12 }}>{formatDate(b.checkin_date)}</Td>
                <Td style={{ fontSize: 12, textAlign: 'center' }}>{b.nights}</Td>
                <Td style={{ fontWeight: 500 }}>{formatCurrency(b.total_price)}</Td>
                <Td style={{ fontSize: 11, color: '#888780' }}>{b.agent_name}</Td>
                <Td><Badge status={b.status} /></Td>
              </Tr>
            ))}
          </Table>
        </Card>
      </div>
    </div>
  );
};
